import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rappider-environment-variables',
  templateUrl: './environment-variables.component.html',
  styleUrls: ['./environment-variables.component.scss']
})
export class EnvironmentVariablesComponent implements OnInit {

  ngOnInit(): void {
    console.log('Component initialized.');
  }

}
